/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { subscriptionApi } from '@/api';
import {
  Subscription,
  SubscriptionStatusString,
  RenderPageOrderConstant,
  Store,
} from '@/types';
import {
  errorHandlingGlobal,
  getItemFromLocalStorage,
  setItemToLocalStorage,
} from '@/utils/helper';
import store from '@/store';
import {
  storeValidatePromoRes,
  initialState,
  getValidatePromoRes,
} from '@/store/commonDuck/promoDuck';
import {
  getHTPPErrorInfoEvent,
  storeHTPPErrorInfoEvent,
} from '@/store/commonDuck/NotificationDuck';
import { storeSubscription } from '@/store/orderDuck';
import { useTranslate } from '@/locale';
import { useQuery } from '@/utils/hooks';
import {
  getShippingInfoState,
  setPickedCourier,
} from '@/store/shippingInfoDuck';
import OrderView from './OrderView';
import {
  IS_PATREP_KEY,
  PAYMENT_STATUS_LIST,
  DETAIL_SUBSCRIPTION_STATUS_LIST,
} from './constants';

const Order = (props: any) => {
  const {
    validatePromoData,
    shippingInfo,
    storeSubscriptionAction,
    setPickedCourierAction,
    httpErrorInfoEvent,
  } = props;
  const { subscriptionID } = useParams<{ subscriptionID: string }>();
  const [loadingGetSubscription, setLoadingGetSubscription] = useState<boolean>(
    false
  );
  const [subscription, setSubscription] = useState<Subscription>(
    {} as Subscription
  );
  const [renderPageOrderConstant, setRenderPageOrderConstant] = useState<
    RenderPageOrderConstant
  >({} as RenderPageOrderConstant);
  const [noteInput, setNoteInput] = useState<string>('');

  const [isPaymentSucessfull, setIsPaymentSucessfull] = useState<boolean>(
    false
  );

  const savedPatrepKey = IS_PATREP_KEY + subscriptionID;
  const queryIsPatrep = useQuery().get(IS_PATREP_KEY);
  const [isPatrep, setIsPatrep] = useState<string | null>(queryIsPatrep);

  const { translate } = useTranslate();

  const checkIfPaymentSucessfull = (status: SubscriptionStatusString) => {
    setIsPaymentSucessfull(
      PAYMENT_STATUS_LIST.find(each => each === status) !== 'payment_failed'
    );
  };

  const checkStatusSubscription = (status: SubscriptionStatusString) => {
    if (DETAIL_SUBSCRIPTION_STATUS_LIST.find(each => each === status)) {
      setRenderPageOrderConstant({ page: 'DETAIL_SUBSCRIPTION' });
      return;
    }
    if (PAYMENT_STATUS_LIST.find(each => each === status)) {
      setRenderPageOrderConstant({ page: 'PAYMENT_STATUS_PAGE' });
    }
  };

  const getSubscription = async () => {
    try {
      setLoadingGetSubscription(true);
      const { data } = await subscriptionApi.getSubscriptionDetail(
        subscriptionID,
        isPatrep
      );
      checkStatusSubscription(data.status);
      checkIfPaymentSucessfull(data.status);
      setSubscription(data);
      storeSubscriptionAction(data);
    } catch (error) {
      const { data } = error;
      if (data && data.error_code === 'SUBSCRIPTION_NOT_FOUND') {
        store.dispatch(
          storeHTPPErrorInfoEvent({
            isOpen: true,
            type: 'SUBSCRIPTION_NOT_FOUND',
          })
        );
      }
      errorHandlingGlobal(error);
    } finally {
      setLoadingGetSubscription(false);
    }
  };

  const calculatePromo = async (promoCode: string, name: string) => {
    try {
      const { data } = await subscriptionApi.calculatePromo(subscription.id, {
        promo_code: promoCode,
      });
      store.dispatch(storeValidatePromoRes(data));
    } catch (error) {
      errorHandlingGlobal(error, {
        '400': errorFromCallback => {
          store.dispatch(
            storeValidatePromoRes({
              ...initialState.validatePromoRes,
              name,
              promo_code: promoCode,
              errorCode: errorFromCallback.data.error_code,
            })
          );
        },
      });
    }
  };

  const renderTitle = () => {
    if (subscription.status === 'pending_address') {
      return `Detail Order No ${subscription.id}`;
    }
    if (
      subscription.status === 'waiting_for_payment' ||
      subscription.status === 'payment_order'
    ) {
      return translate('completeYourPayment');
    }
    return 'Lifepack For Patient';
  };

  useEffect(() => {
    if (
      !validatePromoData.promo_code &&
      subscription.promo &&
      subscription.status !== 'pending_address'
    ) {
      const { payment, promo } = subscription;
      const data = {
        all_payment: promo.all_payment,
        description: promo.description,
        discount: promo.discount,
        final_price: payment.total_price,
        name: promo.name,
        promo_code: promo.code,
      };
      store.dispatch(storeValidatePromoRes(data));
    }
  }, [subscription]);

  useEffect(() => {
    getSubscription();
  }, []);

  useEffect(() => {
    if (isPatrep) {
      setItemToLocalStorage(savedPatrepKey, isPatrep);
    } else {
      const savedID = getItemFromLocalStorage(savedPatrepKey);
      setIsPatrep(savedID);
    }
  }, [isPatrep]);

  return loadingGetSubscription ? null : (
    <OrderView
      noteInput={noteInput}
      setNoteInput={setNoteInput}
      renderPageConstant={renderPageOrderConstant}
      subscription={subscription}
      setSubscription={setSubscription}
      setRenderPageOrderConstant={setRenderPageOrderConstant}
      getSubscription={getSubscription}
      calculatePromo={calculatePromo}
      validatePromoData={validatePromoData}
      isPaymentSucessfull={isPaymentSucessfull}
      pickedCourier={shippingInfo.pickedCourier}
      setPickedCourier={setPickedCourierAction}
      renderTitle={renderTitle}
      httpErrorInfoEvent={httpErrorInfoEvent}
    />
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      storeSubscriptionAction: storeSubscription,
      setPickedCourierAction: setPickedCourier,
    },
    dispatch
  );
};

const mapStateToProps = (state: Store) => ({
  validatePromoData: getValidatePromoRes(state.promo),
  shippingInfo: getShippingInfoState(state.shippingInfo),
  httpErrorInfoEvent: getHTPPErrorInfoEvent(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Order);
